module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_yosoplus-81dc2438fdf951a389233839e4a23bd5.jpg";